import { Icon, IconDefinitions } from "../../../../components";

interface NoDataReceivedCardProps {
  isFailed: boolean;
  errorMessage?: string;
}

export function NoDataReceivedCard({ isFailed, errorMessage }: NoDataReceivedCardProps) {
  return (
    <div className="d-flex flex-column align-items-center py-4">
      <Icon
        iconName={isFailed ? IconDefinitions.warning : IconDefinitions.clock}
        style={{
          color: isFailed ? "#c0392b" : "#6c757d",
          fontSize: "2rem",
        }}
      />
      <small
        className="mt-2"
        style={{ color: isFailed ? "#c0392b" : "#6c757d" }}
      >
        {errorMessage
          ? errorMessage
          : isFailed
            ? "Session failed — no data was received"
            : "Session ended — no data was received"}
      </small>
    </div>
  );
}